import React from 'react'
import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function ConfirmQueueOpDialogOverlay({ message, onConfirm, onCancel, count, ...overlay }) {
  const { t } = useTranslation()
  return (
    <DialogOverlay title={t('queues.confirmOperation', 'Confirm Operation')} {...overlay}>
      <Paragraph size="sm">
        {message ||
          t(
            'queues.confirmOperationMessage',
            'Are you sure you want to perform this operation on the {count} selected rows?',
            { count }
          )}
      </Paragraph>
      <DialogOverlayActions>
        <Button emphasis="high" onClick={onConfirm}>
          {t('action.confirm', 'Confirm')}
        </Button>
        <Button emphasis="medium" onClick={onCancel}>
          {t('action.cancel', 'Cancel')}
        </Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
